import React from 'react'
import AgendaFormFilterDatesButtons from './AgendaFormFilterDatesButtons'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

const AgendaFormFilterDates = ({FilterDateIsOpen, OnClickDatePickerOpenClose, FilterDateCurrent, OnClickDatePickerReset, OnClickDatePickerThisDay, OnClickDatePickerThisWeek, OnClickDatePickerThisWeekend, datePickerShowStartValue, datePickerStartValue, OnChangeDatePickerStart, datePickerShowEndValue, datePickerEndValue, OnChangeDatePickerEnd}) => {
	// Validation des props et gestion des erreurs
	if (typeof OnClickDatePickerOpenClose !== 'function') {
		return (
			<div role="region" aria-label="Filtre de dates d'événements" className="agenda-form-filter-dates-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : fonction de gestion des dates manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Gestion des événements clavier
	const handleKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			OnClickDatePickerOpenClose(event)
		}
	}

	// Construction des aria-label pour les composants
	const startDateLabel = "Sélectionner la date de début"
	const endDateLabel = "Sélectionner la date de fin"
	const currentDateLabel = `Date actuellement sélectionnée : ${FilterDateCurrent || 'Aucune date'}`

	return (
		<div 
			className={FilterDateIsOpen ? 'agenda-filters-dates isOpen' : 'agenda-filters-dates'} 
			role="group" 
			aria-label="Filtre de dates d'événements"
			aria-describedby="agenda-form-filter-dates-description"
		>
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="agenda-form-filter-dates-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				Filtre pour sélectionner la période d'événements à afficher dans l'agenda
			</div>

			<div className="agenda-filters-dates-content" role="region" aria-label="Contenu du filtre de dates">
				<div className="agenda-filters-dates-header" aria-label="En-tête du filtre de dates">
					<div className="agenda-filters-dates-current" role="group" aria-label="Date actuellement sélectionnée">
						<button 
							className="agenda-filters-dates-current-name" 
							onClick={OnClickDatePickerOpenClose} 
							onKeyDown={handleKeyDown}
							aria-label={currentDateLabel}
							aria-expanded={FilterDateIsOpen}
							aria-controls="agenda-form-filter-dates-popin"
							aria-describedby="agenda-form-filter-dates-description"
						>
							{FilterDateCurrent || 'Sélectionner une date'}
						</button>
					</div>
				</div>

				<div 
					id="agenda-form-filter-dates-popin"
					className="agenda-filters-dates-popin" 
					role="region" 
					aria-label="Sélecteur de dates"
					aria-hidden={!FilterDateIsOpen}
				>
					<div role="group" aria-label="Boutons de sélection rapide de dates">
						<AgendaFormFilterDatesButtons 
							OnClickDatePickerReset={OnClickDatePickerReset} 
							OnClickDatePickerThisDay={OnClickDatePickerThisDay}
							OnClickDatePickerThisWeek={OnClickDatePickerThisWeek}
							OnClickDatePickerThisWeekend={OnClickDatePickerThisWeekend}
						/>
					</div>

					<div className="agenda-filters-dates-datepickers" role="group" aria-label="Sélecteurs de dates personnalisées">
						<div className="agenda-filters-dates-datepickers-mini-cal" role="group" aria-label="Sélecteur de date de début">
							<h3 className="agenda-filters-dates-datepickers-mini-cal-title" id="start-date-title">
								Date de début
							</h3>
							<div role="application" aria-labelledby="start-date-title" aria-label={startDateLabel}>
								<DatePicker 
									selected={datePickerShowStartValue ? datePickerStartValue : null} 
									onChange={OnChangeDatePickerStart} 
									dateFormat="YYYY-MM-DD"
									inline
									selectsStart 
									locale="fr"
									aria-label={startDateLabel}
									aria-describedby="agenda-form-filter-dates-description"
								/> 
							</div>
						</div>

						<div className="agenda-filters-dates-datepickers-mini-cal" role="group" aria-label="Sélecteur de date de fin">
							<h3 className="agenda-filters-dates-datepickers-mini-cal-title" id="end-date-title">
								Date de fin
							</h3>
							<div role="application" aria-labelledby="end-date-title" aria-label={endDateLabel}>
								<DatePicker 
									selected={datePickerShowEndValue ? datePickerEndValue : null} 
									onChange={OnChangeDatePickerEnd} 
									dateFormat="YYYY-MM-DD"
									inline
									selectsEnd 
									locale="fr"
									aria-label={endDateLabel}
									aria-describedby="agenda-form-filter-dates-description"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Message de statut pour les lecteurs d'écran */}
			<div 
				className="visually-hidden" 
				aria-live="polite" 
				aria-label="Statut du filtre de dates"
			>
				{FilterDateIsOpen ? 'Sélecteur de dates ouvert' : 'Sélecteur de dates fermé'}
			</div>
		</div>
	)
}

export default AgendaFormFilterDates
